import type { GradePublic } from '@repo/types/grades';
import type { ComponentProps, ReactNode } from 'react';

import GradeDetailsContent from '@/components/features/grades/GradeDetailsContent';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card';
import { useMediaQuery } from '@/hooks/media-query';

interface GradeDetailsPopupProps {
  grade: GradePublic;
  children: ReactNode;
  side?: ComponentProps<typeof HoverCardContent>['side'];
}

export default function GradeDetailsPopup({ grade, children, side }: GradeDetailsPopupProps) {
  const breakpoint = useMediaQuery('sm');

  if (breakpoint) {
    return (
      <HoverCard>
        <HoverCardTrigger asChild>{children}</HoverCardTrigger>
        <HoverCardContent side={side} align={'start'} className={'bg-card border-border-primary w-96 gap-0 overflow-hidden rounded-xl p-0'}>
          <div className={'flex w-full items-center gap-2 p-4'}>
            <span className={'text-foreground truncate text-base font-medium'}>{grade.name}</span>
          </div>
          <GradeDetailsContent grade={grade} />
        </HoverCardContent>
      </HoverCard>
    );
  }

  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className={'bg-card'}>
        <DialogBody>
          <DialogHeader>
            <DialogTitle>{grade.name}</DialogTitle>
          </DialogHeader>
          <DialogDescription className={'sr-only'}>Szczegóły oceny</DialogDescription>
          <GradeDetailsContent grade={grade} />
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
